import { compareStages } from './stage.model';
import { StageInterface } from '@vendasta/sales-opportunities';

export const USER_PIPELINE_TOKEN = 'USER_PIPELINE';
export const USER_PIPELINES_TOKEN = 'USER_PIPELINES';
export const CURRENT_PIPELINE = 'CURRENT_PIPELINE';
export const STAGE_PROBABILITY_DELTA = 0.01;

export class Pipeline {
  stages: StageInterface[];
  id: string;
  name: string;

  constructor(stages: StageInterface[], id: string, name: string) {
    this.stages = stages;
    this.id = id;
    this.name = name;
  }

  findStage(probability: number): StageInterface {
    probability = probability ? probability : 0;
    const sortedStages: StageInterface[] = this.stages.sort(compareStages);
    const foundStage: StageInterface = sortedStages.find((stage) => probability <= stage.probability);
    return foundStage || sortedStages[sortedStages.length - 1];
  }

  findProbabilityRangeFromStage(stage: StageInterface): { minimum: number; maximum: number } {
    if (this.stages.length === 0) {
      throw new Error('Pipeline has no stages');
    }
    const sortedStages: StageInterface[] = this.stages.sort(compareStages);
    const foundStage = sortedStages.find((curStage) => curStage.probability === stage.probability);

    if (foundStage) {
      const indexOfStage = sortedStages.indexOf(foundStage);

      if (sortedStages.length === 1) {
        return { minimum: 0, maximum: 1 };
      }

      if (indexOfStage === 0) {
        return { minimum: 0, maximum: foundStage.probability };
      } else if (indexOfStage > 0 && indexOfStage < sortedStages.length - 1) {
        const lowerProbability = (sortedStages[indexOfStage - 1].probability * 100 + STAGE_PROBABILITY_DELTA) / 100;
        const upperProbability = foundStage.probability;
        return { minimum: lowerProbability, maximum: upperProbability };
      } else if (indexOfStage === sortedStages.length - 1) {
        const maximumProbability = 1;
        const lowerProbability = (sortedStages[indexOfStage - 1].probability * 100 + STAGE_PROBABILITY_DELTA) / 100;
        return { minimum: lowerProbability, maximum: maximumProbability };
      }
    } else {
      // 100 returned if stage not found
      const lowerProbability =
        (sortedStages[sortedStages.length - 2].probability * 100 + STAGE_PROBABILITY_DELTA) / 100;
      return { minimum: lowerProbability, maximum: 1 };
    }
  }
}
